<template>
    <v-container fluid>
        <!-- <v-row justify="start" class="mt-6 ml-1">
            <v-col>
                <v-btn color="success" @click="back()">返回</v-btn>
            </v-col>
        </v-row> -->
        <v-row justify="start" class="mt-6 ml-1">
      
            <v-col cols='12'>
                <v-row>
                    <v-btn color="success" @click="back()">返回</v-btn>
                </v-row>
                <v-row class="mt-10">
                    <h2>LINE Point 匯入</h2>   
                </v-row>
                <v-row class="mt-5">
                    <span class="fontStyle">輸入面額: </span>&nbsp;&nbsp;
                    <v-text-field 
                        v-model="number"
                        style="max-width: 100px !important;"
                        min="0"
                        type="Number"
                        outlined
                    ></v-text-field>
                </v-row>
                <v-row>
                    <v-file-input
                        class="buttonStyle"
                        v-model="files"
                        type="file" 
                        label="上傳檔案"
                        accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" 
                        single-line
                        >
                    </v-file-input>
                </v-row>
                <v-row>
                    <span class="mt-2">(請依照指定欄位格式進行匯入)</span>
                </v-row>
                <v-row>
                    <v-btn class="mt-5" color='success' @click="importData()">匯入</v-btn>       
                </v-row>
            </v-col>
        </v-row>

    </v-container>
</template>

<script>
import bus from '../nav/bus'

var host_url = process.env.VUE_APP_HOST_URL 
export default {
    data(){
        return {
            formData: new FormData(),
            files: [],
            number: 0,            
            vendor_id: parseInt(localStorage.getItem('vendor_id')),
        }
    },
    created(){
    },
    methods: {
        back(){
            this.$router.push('/line_point_setting')
        },
        importData(){
            if(this.number == 0){ bus.$emit('alert', {msg: "面額不能為 0", title: "提示",　check: "我知道了"}); return }
            console.log(this.files)
            if(this.files.length == 0){ bus.$emit('alert', {msg: "尚未上傳檔案", title: "提示",　check: "我知道了"}); return }
            this.formData.append('number', this.number)
            this.formData.append('file', this.files)
            axios.post(host_url+'import_line_point/', this.formData, {headers: {
                'Content-Type': 'multipart/form-data'
            }})
            .then(response => {
                let tmp = response.data
                if(tmp.status == true){
                    bus.$emit('alert', {msg: tmp.msg, title: "提示",　check: "我知道了"})
                }
                else{
                    bus.$emit('alert', {msg: tmp.msg, title: "錯誤提示",　check: "我知道了"})
                }
            })
            .catch((error) => {
                console.log(error)
            })
        },
        handleUploadFile(){
            console.log(this.files)
        }

    }
}
</script>

<style scoped>
.fontStyle{
    line-height: 3.5;
}
.buttonStyle{
    max-width: 160px !important;
}
</style>